// @ts-check
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

import Divider from '@material-ui/core/Divider';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import BusinessIcon from '@material-ui/icons/Business';
import GroupIcon from '@material-ui/icons/Group';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import LocalShipping from '@material-ui/icons/LocalShipping';
import { getClients } from '../../../clients/presentation/redux/actions/client-actions';
import { LoadingComponent } from '../components/loading-component';
import { FloatingActionButtonSize } from '../../../clients/presentation/components/add-component';
import { Clients } from '../../../clients/presentation/pages/clients-page';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0),
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  sectionHeading: {
    margin: theme.spacing(2)
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    cursor: 'pointer'
  },
  container: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2)
  },
  clientLogo: {
    height: '8rem',
    width: '8rem',
    objectFit: 'contain'
  },
  icon: {
    fontSize: '4em'
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  heading: {
    margin: theme.spacing(2)
  }
}));

function Menu() {
  const classes = useStyles();
  const history = useHistory();
  return (
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <Paper className={classes.paper} elevation={0} onClick={() => history.push('/clients')}>
          <BusinessIcon className={classes.icon} fontSize="large" />

          <div>
            <b>Clients</b>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={3}>
        <Paper className={classes.paper} elevation={0} onClick={() => history.push('/users')}>
          <GroupIcon className={classes.icon} fontSize="large" />

          <div>
            <b>Users</b>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={3}>
        <Paper className={classes.paper} elevation={0} onClick={() => history.push('/account')}>
          <AccountCircleIcon className={classes.icon} fontSize="large" />

          <div>
            <b>Account</b>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={3}>
        <Paper className={classes.paper} elevation={0} onClick={() => history.push('/partners')}>
          <LocalShipping className={classes.icon} fontSize="large" />
          <div>
            <b>3PL Partners</b>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default function HomePage() {
  const classes = useStyles();

  const { clients, loading } = useSelector((state) => state.clients);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getClients());
  }, [dispatch]);

  return (
    <>
      <React.Fragment>
        <CssBaseline />
        <Container className={classes.container}>
          {loading && <LoadingComponent />}
          {!loading && (
            <>
              <FloatingActionButtonSize />
              <Menu />
              <Divider className={classes.divider} />

              <Typography
                variant="subtitle2"
                component="h3"
                align="center"
                className={classes.heading}
              >
                <small>
                  <b>Clients </b>
                </small>
              </Typography>

              <Clients clients={clients} />
            </>
          )}
        </Container>
      </React.Fragment>
    </>
  );
}
